import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { usePageContext } from '../context/pageContext';
import { CTA } from '../html-tag/Cta';
import { LocalLink } from '../html-tag/localLink';
import { Blocks } from '../ui/blocks/Blocks';
import * as styles from './homeSection.module.scss';
import { SanityHomeSection } from '../../../graphql-types';
import slugify from 'slugify';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityHomeSection;
}

export const HomeSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();

  const therapistPageSlug = slugify(
    (
      section?.therapistPage?.pageSlug?.find((el) => el?.language === lang)?.text ??
      section?.therapistPage?.pageSlug?.find((el) => el?.language === defaultLang)?.text ??
      ''
    ).toLowerCase(),
  );

  const patientPageSlug = slugify(
    (
      section?.patientPage?.pageSlug?.find((el) => el?.language === lang)?.text ??
      section?.patientPage?.pageSlug?.find((el) => el?.language === defaultLang)?.text ??
      ''
    ).toLowerCase(),
  );

  return (
    <div className={styles.wrapper}>
      <LocalLink
        className={styles.halfContainer}
        to={`/${therapistPageSlug}`}
      >
        <div className={styles.image}>
          <GatsbyImage
            image={section?.therapistImage?.img?.asset?.gatsbyImageData}
            alt={section?.patientImage?.alt ?? ''}
            loading="eager"
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            <div className={styles.black} />
            <h4>{findTranslation(section?._rawTherapist, lang, defaultLang)}</h4>
            <h2>{findTranslation(section?._rawTherapistTitle, lang, defaultLang)}</h2>
            <h4>{findTranslation(section?._rawTherapistSubtitle, lang, defaultLang)}</h4>
            <CTA
              label={findTranslation(section?._rawTherapistCta, lang, defaultLang)}
              dataType={'orange'}
              to={`/${therapistPageSlug}`}
              noLink
            />
          </div>
        </div>
      </LocalLink>
      <LocalLink
        className={styles.halfContainer}
        to={`/${patientPageSlug}`}
      >
        <div className={styles.image}>
          <GatsbyImage
            image={section?.patientImage?.img?.asset?.gatsbyImageData}
            alt={section?.patientImage?.alt ?? ''}
            loading="eager"
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            <div className={styles.black} />
            <h4>{findTranslation(section?._rawPatient, lang, defaultLang)}</h4>
            <h2>{findTranslation(section?._rawPatientTitle, lang, defaultLang)}</h2>
            <h4>{findTranslation(section?._rawPatientSubtitle, lang, defaultLang)}</h4>
            <CTA
              label={findTranslation(section?._rawPatientCta, lang, defaultLang)}
              dataType={'orange'}
              to={`/${patientPageSlug}`}
              noLink
            />
          </div>
        </div>
      </LocalLink>
      <div className={styles.overlay}></div>
      <div className={styles.logoText}>
        <div className={styles.logo}>
          <GatsbyImage
            image={section?.homeLogoSection?.logoImg?.asset?.gatsbyImageData ?? ''}
            alt={section?.homeLogoSection?.logoAlt ?? ''}
            loading="eager"
          />
        </div>
        <div className={styles.text}>
          <div>
            <Blocks blocks={findTranslation(section?._rawHomeTextSection, lang, defaultLang)} />
          </div>
        </div>
      </div>
    </div>
  );
};
